module.exports = __webpack_public_path__ + "static/media/dashboard_banner_desktop.c0cd3ac4.png";